module.exports = __webpack_public_path__ + "img/vf_retail-2.fdefa168.png";